module.exports = __webpack_public_path__ + "static/img/10.6c23cb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/10.png
// module id = k3oG
// module chunks = 0